import "./NSFWDialog.css.js?css";
export const actions = '_139rjd51';
export const checkbox = '_139rjd52';
export const dialog = '_139rjd50';